import { Controller } from "@hotwired/stimulus"

// Toggles the visibility of a panel target element by adding/removing the `hidden` class.
// Used for mobile participant sidebar toggle in staff thread views.
//
// Usage:
//   <div data-controller="panel-toggle">
//     <button data-action="click->panel-toggle#toggle">Toggle</button>
//     <div data-panel-toggle-target="panel" class="hidden lg:block">
//       Panel content
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["panel"]

  declare readonly panelTarget: HTMLElement
  declare readonly hasPanelTarget: boolean

  toggle(): void {
    if (!this.hasPanelTarget) return

    this.panelTarget.classList.toggle("hidden")
  }
}
